import { Check } from "@dreamhub/designsystem/icons";
import IconContainer from "@/components/ui/icon-container";
import Text from "@/components/ui/text";
import { cn } from "@/utils/utils";

interface Props {
  label: string;
  isSelected: boolean;
  onClick: () => void;
}

const DatePresetItem: React.FC<Props> = ({ label, isSelected, onClick }) => (
  <div
    onClick={onClick}
    className={cn(
      "flex items-center justify-between gap-2 px-3 py-2 cursor-pointer rounded-lg",
      "hover:bg-surface-hover-soft active:bg-surface-pressed",
      "transition-all duration-200 ease-in-out"
    )}
  >
    <Text>{label}</Text>
    <IconContainer
      className={cn(
        "transition-opacity duration-200",
        isSelected ? "opacity-100" : "opacity-0"
      )}
    >
      <Check />
    </IconContainer>
  </div>
);

export default DatePresetItem;
